import { rem } from "polished";
import styled from "styled-components";

const ImageWrapper = styled.div`
  transform: translate(0);
`;

const Backdrop = styled.div<{ imageSrc: string }>`
  position: fixed;
  top: ${rem(-20)};
  bottom: ${rem(-20)};
  left: ${rem(-20)};
  right: ${rem(-20)};
  background-image: ${({ imageSrc }) => `url(${CSS.escape(imageSrc)})`};
  background-size: cover;
  filter: blur(${rem(10)});
`;

const ImageBackdrop = ({ children, backgroundImageSrc }) => (
  <ImageWrapper>
    <Backdrop imageSrc={backgroundImageSrc} />
    {children}
  </ImageWrapper>
);

export default ImageBackdrop;
